import React, { useContext, useEffect, useState } from 'react';
import { Badge, Button, Card, Col, Collapse, Form, Row } from '@themesberg/react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { Context, todayInput } from '../Ticket';

const fields = [
  ['cartId', 'Mã đơn', 'text'], ['ticketId', 'Mã vé', 'text'], ['phone', 'Số điện thoại', 'tel'],
  ['gamePeriodId', 'Mã kỳ quay', 'text'], ['customerName', 'Tên người chơi', 'text'],
  ['from', 'Từ ngày', 'date'], ['to', 'Đến ngày', 'date'],
];
export default function FilterForm() {
  const { state, dispatch } = useContext(Context);
  const games = state.games || [];
  const [expanded, setExpanded] = useState(false);
  const [draft, setDraft] = useState({});
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    setDraft({ cartId: state.cartId, ticketId: state.ticketId, phone: state.phone,
      gamePeriodId: state.gamePeriodId, customerName: state.customerName,
      from: state.from, to: state.to, gameId: state.gameId });
  }, [state.cartId, state.ticketId, state.phone, state.gamePeriodId, state.customerName, state.from, state.to, state.gameId, state.gameScope]);
  const update = (key, value) => setDraft(current => ({ ...current, [key]: value }));
  const submit = event => {
    event.preventDefault();
    dispatch({ type: 'SUBMIT_FILTER', payload: { ...draft, gameId: state.gameScope === 'other' ? draft.gameId || '' : '' } });
  };
  const reset = () => {
    history.replace({ pathname: location.pathname, search: `?tab=${state.gameScope || 'keno'}` });
    dispatch({ type: 'SUBMIT_FILTER', payload: { cartId: '', ticketId: '', phone: '', gamePeriodId: '',
      customerName: '', gameId: '', from: todayInput(), to: todayInput(), statusGroup: 'all' } });
  };
  const formatDate = value => value ? value.split('-').reverse().join('/') : 'Không giới hạn';
  const dates = state.from === todayInput() && state.to === todayInput()
    ? `Hôm nay: ${formatDate(state.from)}` : `${formatDate(state.from)} – ${formatDate(state.to)}`;
  const gameLabel = state.gameScope === 'keno' ? 'Keno'
    : games.find(game => game.id === state.gameId)?.name || (state.gameId || 'Tất cả trò chơi ngoài Keno');
  return <Card border="light" className="shadow-sm">
    <Card.Header className="bg-white p-0">
      <button type="button" className="w-100 border-0 bg-transparent px-3 py-2 text-start d-flex align-items-center justify-content-between flex-wrap gap-2"
        aria-expanded={expanded} aria-controls="ticket-search-fields" onClick={() => setExpanded(value => !value)}>
      <div className="d-flex align-items-center flex-wrap gap-2">
        <strong className="me-1">Bộ lọc</strong>
        <Badge bg="light" text="dark">{dates}</Badge>
        <Badge bg="light" text="dark">{state.gameScope ? gameLabel : 'Đang xác định trò chơi...'}</Badge>
        {fields.filter(([key, , type]) => type !== 'date' && state[key]).map(([key, label]) =>
          <Badge key={key} bg="light" text="dark">{label}: {state[key]}</Badge>)}
      </div>
      <span className="text-primary text-nowrap">{expanded ? 'Thu gọn bộ lọc ▴' : 'Mở rộng bộ lọc ▾'}</span>
      </button>
    </Card.Header>
    <Collapse in={expanded}>
      <div id="ticket-search-fields">
        <Form onSubmit={submit}>
          <Card.Body className="p-3">
            <Row className="g-2">
              {state.gameScope === 'other' && <Col md={6} xl={3}>
                <Form.Group controlId="ticket-filter-game-id">
                  <Form.Label className="small mb-1">Trò chơi</Form.Label>
                  <Form.Select id="ticket-filter-game-id" size="sm" value={draft.gameId || ''} onChange={e => update('gameId', e.target.value)}>
                    <option value="">Tất cả trò chơi ngoài Keno</option>
                    {games.filter(game => game.id !== 'keno').map(game => <option key={game.id} value={game.id}>{game.name}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>}
              {fields.map(([key, label, type]) => <Col key={key} md={6} xl={3}>
                <Form.Group controlId={`ticket-filter-${key}`}>
                  <Form.Label className="small mb-1">{label}</Form.Label>
                  <Form.Control size="sm" type={type} value={draft[key] || ''} placeholder={`Nhập ${label.toLowerCase()}`}
                    onChange={e => update(key, e.target.value)} />
                </Form.Group>
              </Col>)}
            </Row>
          </Card.Body>
          <Card.Footer className="bg-white p-2 d-flex justify-content-end gap-2">
            <Button variant="outline-secondary" size="sm" onClick={reset}>Xóa bộ lọc</Button>
            <Button variant="info" size="sm" type="submit" disabled={state.isFilterLoading || !state.gameScope}>
              {state.isFilterLoading ? 'Đang tải...' : 'Áp dụng bộ lọc'}
            </Button>
          </Card.Footer>
        </Form>
      </div>
    </Collapse>
  </Card>;
}
